import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-estrenimiento',
  templateUrl: './estrenimiento.component.html',
  styleUrls: []
})
export class EstrenimientoComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Tienes estreñimiento? Cómbatelo eficazmente con Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"¿Tienes estreñimiento? Cómbatelo eficazmente con Sinuberase",
  		description: "Los probióticos de Sinuberase modulan el tránsito y capacidad de absorción del colon, regulando también la flora intestinal del paciente estriñido",
  		slug: "Estrenimiento"
  	})

  	this.seo.closeMenu();
  }

}
